import React, { useRef, useEffect, useState } from 'react';
import heart_path from 'heart_path.svg';
import ReactSVG from 'react-svg';
import axios from 'axios';
import { useLazyQuery } from 'react-apollo';
import { useInView } from 'react-intersection-observer';
import { toast } from 'react-toastify';
import { decode } from 'html-decoder';
import { disableBodyScroll } from 'body-scroll-lock';
import Ratings from '../Ratings';
import { handleHeartAnimation } from '../../utils/handleHeartAnimation';
import FavoriteSuccessBanner from '../CustomToast/FavoriteSuccessBanner';
import { communityQuery } from '../../constants/queries';

export default function MobileRentalActiveMarker({ item, userData }) {
  const heartRef = useRef(null);

  const [favorited, setFavorited] = useState(false);
  useEffect(() => {
    if (item.favorited) {
      setFavorited(true);
    }
  }, [item]);

  const [favoriteRoute, setFavoriteRoute] = useState(null);
  useEffect(() => {
    setFavoriteRoute(window.Routes.toggle_favorite_property_path(item));
  }, [item]);

  const [ref, inView] = useInView({
    threshold: 0,
  });

  // Get community info
  const [fetchCommunityData, { data: communityData }] = useLazyQuery(
    communityQuery
  );

  useEffect(() => {
    if (inView) {
      fetchCommunityData({ variables: { id: item.comm_id } });
    }
    // eslint-disable-next-line
  }, [fetchCommunityData, inView]);

  const handleFavorited = () => {
    const tokenElement = document.querySelector('[name=csrf-token]');
    if (userData && userData.user && userData.user.id) {
      handleHeartAnimation({ ref: heartRef, isFavorited: favorited });
      axios
        .patch(favoriteRoute, null, {
          headers: {
            'X-CSRF-Token': tokenElement ? tokenElement.content : '',
            Accept: 'application/json',
          },
        })
        .then(res => {
          if (res.status === 200) {
            toast.dismiss();
            if (!favorited)
              toast(<FavoriteSuccessBanner favorited type={item} />);
            else toast(<FavoriteSuccessBanner type={item} />);
            setFavorited(!favorited);
          }
        })
        .catch(err => {
          console.error(err);
          if (err.response.status === 401) {
            window.location.pathname = window.Routes.login_path();
          }
        });
    } else {
      const modal = document.querySelector('#popup-modal');
      modal.classList.remove('fadeOut');
      modal.classList.remove('hidden');
      modal.classList.add('fadeIn');
      disableBodyScroll(modal);
    }
  };

  return (
    <div ref={ref} className="mobile-rental-active-marker">
      <button
        aria-label="Toggle Favorite"
        name="Toggle Favorite"
        ref={heartRef}
        type="button"
        className={`card-heart rental-favorite ${
          item.favorited ? 'favorited' : ''
        }`}
        onClick={handleFavorited}
      >
        <ReactSVG src={heart_path} className="heart-icon" />
      </button>

      <a href={item.property_url}>
        <section className="image-section-wrapper">
          <img
            src={item.image_url}
            alt={`${item.name}`}
            aria-label={`${item.name}`}
          />
          <div className="image-overlay" />
          <Ratings
            rating={item.rating}
            rating_count={item.rating_count}
            secondaryColor
          />
        </section>

        <section className="info-section-wrapper">
          <div>
            <h4 className="item-type">{item.property_type}</h4>
            <h3 className="item-name">{decode(item.name)}</h3>
          </div>
          <ul className="item-details">
            <li>{communityData && decode(communityData.community.name)}</li>
            <li>
              {item.nightly_rate
                ? `Starting at ${item.nightly_rate}/night`
                : 'Inquire for rates'}
            </li>
            <li>
              <span>{item.beds}br</span> | <span>{item.baths}ba</span> |{' '}
              <span>Sleeps {item.sleeps}</span>
            </li>
          </ul>
          <h4 className="property-price">
            {item.nightly_rate ? `$${item.nightly_rate}` : 'Inquire'}
          </h4>
        </section>
      </a>
    </div>
  );
}
